import { h } from "preact";
import { TableComponent } from "../../../../components/table/styled";
import { ITableData } from "../../interfaces/table";

export const TableData = ({
  columns,
  data,
  loading,
}: ITableData): JSX.Element => {
  return (
    <TableComponent
      style={{ textAlign: "center" }}
      columns={columns}
      dataSource={data}
      rowClassName={(record: any) =>
        record.statusName !== "WAITING-QC" ? "green" : ""
      }
      loading={loading}
      bordered
      size="middle"
      scroll={{ x: "max-content" }}
    />
  );
};
